import React, { ChangeEvent, FC } from 'react';

import { Textarea } from 'src/common/form/textarea';
import { TextInput } from 'src/common/form/text-input';
import { ToggleComponent } from 'src/common/form/toggle/component';

interface StepEditorContentBehaviorExternalLinkOptionsProps {
  linkTitle: string;
  linkDescription: string;
  hideThumbnail: boolean;
  setLinkTitle: (title: string) => unknown;
  setLinkDescription: (description: string) => unknown;
  setHideThumbnail: (hideThumbnail: boolean) => unknown;
}

export const StepEditorContentBehaviorExternalLinkOptions: FC<StepEditorContentBehaviorExternalLinkOptionsProps> = ({
  linkTitle,
  linkDescription,
  hideThumbnail,
  setLinkTitle,
  setLinkDescription,
  setHideThumbnail,
}) => {
  return (
    <div className='flex flex-col space-y-sm'>
      <TextInput
        id='editor_content_form_link_title'
        inputProps={{
          type: 'text',
          name: 'link_title',
          value: linkTitle,
          placeholder: 'Link title',
        }}
        onChange={(e: ChangeEvent<HTMLInputElement>) => setLinkTitle(e.target.value)}
        required={false}
        hideOptional={true}
      />
      <Textarea
        containerClasses='flex-1'
        inputClasses='h-24 pr-10'
        value={linkDescription}
        onChange={(e: ChangeEvent<HTMLTextAreaElement>) => setLinkDescription(e.target.value)}
        required={false}
        placeholder='Link description'
        id='behavior-textarea'
        label=''
        helperText=''
      />
      <ToggleComponent
        checked={!hideThumbnail}
        onChange={(value) => setHideThumbnail(!value)}
        label='Include thumbnail'
      />
    </div>
  );
};
